import{a as r}from"./chunk-WIMGWYZL.js";function d(...n){return r(o,n)}var o=(n,a)=>{for(let e=n.length-1;e>=0;e--)if(a(n[e],e,n))return e;return-1};export{d as a};
